export const ADD_RESPONSE = "ADD_RESPONSE";
export const REMOVE_RESPONSE = "REMOVE_RESPONSE";
export const EDIT_RESPONSE = "EDIT_RESPONSE";
export const FETCH_RESPONSE = "FETCH_RESPONSE";
export const CLEAR_RESPONSE = "CLEAR_RESPONSE";
